import React from "react";
import styled from "styled-components";

const Divider = ({ color, className }) => {
  const Wrap = styled.div`
    width: 100vw;
    position: absolute;
    left: 0;
    z-index: 100;
  `;

  const Div = styled.div`
    width: 80%;
    height: 1.6vw;
    background-color: ${props => props.theme.colors[color]};
    display: inline-block;
    transform: translate(-50%, -50%) skew(45deg);
    left: 50%;
    position: absolute;
    z-index: 1;
  `;
  const Diamond = styled.div`
    border: 1.1vw solid ${props => props.theme.colors[color]};
    border-top-color: transparent;
    border-left-color: transparent;
    display: inline-block;
    transform-origin: 50% 0%;
    transform: translateX(-50%) rotate(45deg);
    left: 50%;
    position: absolute;
    z-index: 1;
  `;
  
  return (
    <Wrap className={className}>
      <Div />
      <Diamond />
    </Wrap>
  );
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/Divider/index.js